import { APP_BASE_HREF } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { API_BASE_URL, APP_SHELL_ROUTE_PREFIX } from '@mm-aggregator/drf-dynamics';
import { provideMarkdown } from 'ngx-markdown';

import { authInterceptor, unauthorizedInterceptor } from './interceptors/auth.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';
import { routes } from './app.routes';
import { environment } from '../environments/environment';

/** Match `<base href>` from index.html for APIs that need an app-root-relative URL (e.g. api-docs static files). */
function appBaseHrefFactory(): string {
  if (typeof document === 'undefined') {
    return '/';
  }
  const href = document.querySelector('base')?.getAttribute('href');
  if (href == null || href === '') {
    return '/';
  }
  return href.endsWith('/') ? href : `${href}/`;
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: APP_BASE_HREF, useFactory: appBaseHrefFactory },
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ),
    provideHttpClient(
      withFetch(),
      // Token-based auth: authInterceptor adds Bearer token, unauthorizedInterceptor handles 401
      withInterceptors([authInterceptor, unauthorizedInterceptor, errorInterceptor])
    ),
    provideMarkdown(),
    { provide: API_BASE_URL, useValue: environment.apiUrl },
    { provide: APP_SHELL_ROUTE_PREFIX, useValue: 'app' },
  ],
};
